const deliveryChannelTypes = {
  APPLICATION: 'APPLICATION',
  EMAIL: 'EMAIL',
  TWITTER: 'TWITTER',
  FACEBOOK: 'FACEBOOK',
  INSTAGRAM: 'INSTAGRAM',
  LINKED_IN: 'LINKED_IN',
  SMS: 'SMS'
};

export default deliveryChannelTypes;